module.exports = __webpack_public_path__ + "img/resource-tech-image-46.326994c8.jpg";